export enum Methods {
  POST = 'post',
  DELETE = 'delete',
  GET = 'get',
  PATCH = 'patch',
  PUT = 'put',
}

export interface IApiParams<T> {
  route: string;
  payload?: T;
  method: Methods;
}
